import moment from 'moment'
import { combineReducers } from "redux";
import { createReducer, createNamespacer } from '../commons/js/utils/reducer';


const initialState = {
    spoolsPerProject: {
        graphProjects: [],
        graphSpools: [],
        graphUploadDate:[],
        isLoading: false,
        fromDate: moment().startOf('week'),
        endDate: moment().endOf('week'),
    },
    truckLoads: {
        truckLoadsData: {},
        truckCount: 0,
        loadCount: 0,
        packageCount: 0,
        spoolCount: 0,
        isLoading: false,
        fromDate: moment().startOf('week'),
        endDate: moment().endOf('week'),
        fabMaterials: [],
        material: { label: '', value: '' }
    },
    pipeSize: {
        pipeSize: [],
        pipeSizePercentage: [],
        backgroundColor: [],
        isLoading: false,
        fromDate: moment().subtract(1, 'days'),
    },
    weldAndFitup: {
        dataSet: [],
        isLoading: false,
        fromDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
        fabMaterials: [],
        material: [],
        type: "size",
        showPopup: false,
        dataExceedMessage: "",
    },
    linearFeet: {
        isLoading: false,
        fromDate: moment().subtract(1, 'days'),
        endDate: moment().subtract(1, 'days'),
        feetData: [],
        weightData: []
    },
    weldersFittersAverage: {
        isLoading: false,
        fromDate: moment().subtract(30, 'days'),
        endDate: moment(),
        weldersFittersAverageData: {},
        dateRange: [],
        totalWorkingDays: 0,
    },
    weldersAverage: {
        isLoading: false,
        fromDate: moment().subtract(30, 'days'),
        endDate: moment(),
        weldersAverageData: {},
        dateRange: [],
        totalWorkingDays: 0,
    },
    completedWeldActivityStats: {
        weldActivityStats: [],
        isLoading: false,
        currentPage: 1,
        pageCount: 1
    },
    spoolTracking: {
        startDate: moment(),
        endDate: moment(),
        showPopup: false,
        exceededMessage: "",
        list: [],
        projectList: [],
        selectedProject: "",
        searchKey: "",
    }
}

const namespacers = {
    spoolsPerProject: createNamespacer("SPOOL_PER_PROJECT"),
    truckLoads: createNamespacer("TRUCK_LOADS"),
    completedWeldActivityStats: createNamespacer("COMPLETED_WELD_ACTIVITY_STATS"),
    pipeSize: createNamespacer("PIPE_SIZE"),
    weldAndFitup: createNamespacer("WELD_AND_FITTING"),
    linearFeet: createNamespacer("LINEAR_FEET"),
    weldersFittersAverage: createNamespacer("WELDER_FITTER_AVERAGE"),
    weldersAverage: createNamespacer("WELDER_AVERAGE"),
    spoolTracking: createNamespacer("TRACKING_REPORTS"),
}

const spoolPerProjectReducer = createReducer(initialState.spoolsPerProject, {
    [namespacers.spoolsPerProject("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.value
        }
    },

    [namespacers.spoolsPerProject("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            endDate: action.payload.value,
        }
    },
    [namespacers.spoolsPerProject("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.spoolsPerProject("SET_GRAPH_DATA")]: (state, action) => {
        return {
            ...state,
            graphProjects: action.payload.labels,
            graphSpools: action.payload.spoolCount,
            graphUploadDate: action.payload.spoolUploadDate,
        }
    },
})

const linearFeetReducer = createReducer(initialState.linearFeet, {
    [namespacers.linearFeet("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.value
        }
    },

    [namespacers.linearFeet("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            endDate: action.payload.value,
        }
    },
    [namespacers.linearFeet("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.linearFeet("SET_GRAPH_DATA")]: (state, action) => {
        return {
            ...state,
            feetData: action.payload.feetData,
            weightData: action.payload.weightData,
        }
    },
})

const truckLoadsReducer = createReducer(initialState.truckLoads, {
    [namespacers.truckLoads("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.start,
            endDate: action.payload.end,
        }
    },

    [namespacers.truckLoads("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.start,
            endDate: action.payload.end,
        }
    },

    [namespacers.truckLoads("MATERIALS_LIST")]: (state, action) => {
        return {
            ...state,
            fabMaterials: action.payload.value,
            material: {
                label: action.payload.value[0].label,
                value: action.payload.value[0].value,
            }
        }
    },

    [namespacers.truckLoads("SET_MATERIAL")]: (state, action) => {
        return {
            ...state,
            material: action.payload.value
        }
    },

    [namespacers.truckLoads("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.truckLoads("SET_REPORT_DATA")]: (state, action) => {
        return {
            ...state,
            truckLoadsData: action.payload.truckLoadsData,
            truckCount: action.payload.truckCount,
            loadCount: action.payload.loadCount,
            packageCount: action.payload.packageCount,
            spoolCount: action.payload.spoolCount
        }
    },
})

const pipeSizeReducer = createReducer(initialState.pipeSize, {
    [namespacers.pipeSize("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.value
        }
    },
    [namespacers.pipeSize("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.pipeSize("SET_GRAPH_DATA")]: (state, action) => {
        return {
            ...state,
            pipeSize: action.payload.pipeSize,
            pipeSizePercentage: action.payload.pipeSizePercentage,
            backgroundColor: action.payload.backgroundColor,
        }
    },
})

const weldAndFittingReducer = createReducer(initialState.weldAndFitup, {
    [namespacers.weldAndFitup("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.value
        }
    },

    [namespacers.weldAndFitup("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            endDate: action.payload.value,
        }
    },
    [namespacers.weldAndFitup("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.weldAndFitup("SET_MATERIALS")]: (state, action) => {
        return {
            ...state,
            fabMaterials: action.payload.value,
            material: action.payload.value,
        }
    },
    [namespacers.weldAndFitup("SET_MATERIAL")]: (state, action) => {
        return {
            ...state,
            material: action.payload.value,
        }
    },
    [namespacers.weldAndFitup("SET_GRAPH_DATA")]: (state, action) => {
        return {
            ...state,
            dataSet: action.payload.dataset,
        }
    },
    [namespacers.weldAndFitup("SET_TYPE")]: (state, action) => {
        return {
            ...state,
            type: action.payload.value,
        }
    },
    [namespacers.weldAndFitup("SET_SHOW_POPUP")]: (state, action) => {
        return {
            ...state,
            showPopup: action.payload.value,
        }
    },
    [namespacers.weldAndFitup("SET_DATA_EXCEED_MESSAGE")]: (state, action) => {
        return {
            ...state,
            dataExceedMessage: action.payload.value,
        }
    },
})

const weldersFittersAverageReducer = createReducer(initialState.weldersFittersAverage, {
    [namespacers.weldersFittersAverage("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.value
        }
    },

    [namespacers.weldersFittersAverage("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            endDate: action.payload.value,
        }
    },
    [namespacers.weldersFittersAverage("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.weldersFittersAverage("SET_REPORT_DATA")]: (state, action) => {
        return {
            ...state,
            weldersFittersAverageData: action.payload.weldersFittersAverageData,
            dateRange: action.payload.dateRange,
            totalWorkingDays: action.payload.total_working_days,
        }
    },
})

const weldersAverageReducer = createReducer(initialState.weldersAverage, {
    [namespacers.weldersAverage("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            fromDate: action.payload.value
        }
    },

    [namespacers.weldersAverage("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            endDate: action.payload.value,
        }
    },
    [namespacers.weldersAverage("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.weldersAverage("SET_REPORT_DATA")]: (state, action) => {
        return {
            ...state,
            weldersAverageData: action.payload.weldersAverageData,
            dateRange: action.payload.dateRange,
            totalWorkingDays: action.payload.total_working_days,
        }
    },
})

const completedWeldActivityStatsReducer = createReducer(initialState.completedWeldActivityStats, {

    [namespacers.completedWeldActivityStats("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.completedWeldActivityStats("SET_WELD_ACTIVITY_STATS_DATA")]: (state, action) => {
        return {
            ...state,
            weldActivityStats: action.payload.weldActivityStats,
        }
    },
    [namespacers.completedWeldActivityStats("SET_TOTAL_PAGES_COUNT")]: (state, action) => {
        return {
            ...state,
            pageCount: action.payload.value,
        }
    },
    [namespacers.completedWeldActivityStats("SET_CURRENT_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
})

const spoolTrackingReducer = createReducer(initialState.spoolTracking, {
    [namespacers.spoolTracking("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_START_DATE")]: (state, action) => {
        return {
            ...state,
            startDate: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_END_DATE")]: (state, action) => {
        return {
            ...state,
            endDate: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_SHOW_POPUP")]: (state, action) => {
        return {
            ...state,
            showPopup: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_MESSAGE")]: (state, action) => {
        return {
            ...state,
            exceededMessage: action.payload.value,
        }
    }, 
    
    [namespacers.spoolTracking("SET_SPOOL_TRACKING_LIST")]: (state, action) => {
        return {
            ...state,
            list: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_PROJECTS_LIST")]: (state, action) => {
        return {
            ...state,
            projectList: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_SELECTED_PROJECT")]: (state, action) => {
        return {
            ...state,
            selectedProject: action.payload.value,
        }
    },

    [namespacers.spoolTracking("SET_SEARCH_KEY")]: (state, action) => {
        return {
            ...state,
            searchKey: action.payload.value,
        }
    },

    [namespacers.spoolTracking("CLEAR_DATA")]: (state) => {
        return {
            ...state,
            startDate: moment(),
            endDate: moment(),
            selectedProject: "",
            searchKey: "",
        }
    }
})

const reducer = combineReducers({
    spoolPerProject: spoolPerProjectReducer,
    truckLoads: truckLoadsReducer,
    pipeSize: pipeSizeReducer,
    weldAndFitup: weldAndFittingReducer,
    linearFeet: linearFeetReducer,
    weldersFittersAverage: weldersFittersAverageReducer,
    weldersAverage: weldersAverageReducer,
    completedWeldActivityStats: completedWeldActivityStatsReducer,
    spoolTracking: spoolTrackingReducer,
})

export default reducer;